import { motion } from 'framer-motion';
import { Reveal } from './Reveal';

export const Guarantee = () => (
  <section data-testid="guarantee-section" className="relative border-t border-white/5">
    <div className="mx-auto flex max-w-4xl flex-col items-center px-6 py-24 text-center sm:py-32">
      <Reveal>
        <div className="relative">
          <div className="absolute left-1/2 top-1/2 -z-10 h-64 w-64 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/15 blur-[80px]" />
          <motion.img
            data-testid="guarantee-seal"
            src="/assets/seal-guarantee.webp"
            alt="Selo de 7 dias de garantia"
            loading="lazy"
            className="w-44 drop-shadow-[0_0_45px_rgba(212,175,55,0.35)] sm:w-56"
            whileHover={{ rotate: 4, scale: 1.04 }}
            transition={{ type: 'spring', stiffness: 200, damping: 15 }}
          />
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-10 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
          7 dias de garantia <span className="text-gold">incondicional.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.18}>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-neutral-400">
          Entre, explore tudo e sinta a experiência. Se não for para você, devolvemos 100% do valor
          em até 7 dias. Sem perguntas, sem burocracia.
        </p>
      </Reveal>
    </div>
  </section>
);
